"use client";

import { ShrinkDotIcon } from "@hugeicons-pro/core-stroke-rounded";
import ControlIcon from "./ControlIcon";

export function GameControlsExitFullscreen() {
  return <ControlIcon icon={ShrinkDotIcon} color="white" />;
}
